import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { academyApi } from '@/services/academyApi';
import { formatIssued } from '@/components/academy/Diploma';

/* Verificación pública de un diploma de FHC Academy (/diploma/:code): solo nombre, curso y fecha. */
export default function DiplomaVerify() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { academyApi.verifyCertificate(code).then(setData).catch((e) => setError(e.message)); }, [code]);

  return (
    <div className="min-h-screen bg-[#060d1b] flex items-center justify-center px-4 pt-28 pb-16" data-testid="diploma-verify">
      <div className="w-full max-w-md rounded-2xl border border-[#c9a84c]/25 bg-[#0a1628] p-8 text-center shadow-2xl">
        <img src="/logo-fhc-sm.png" alt="Freedom Homes Club" className="mx-auto h-20 w-auto" />
        <p className="mt-4 text-[11px] uppercase tracking-[0.3em] text-[#c9a84c]" style={{ fontFamily: "'Cinzel', serif" }}>FHC Academy</p>
        <h1 className="mt-1 text-xl text-white" style={{ fontFamily: "'Playfair Display', serif" }}>Verificación de diploma</h1>
        <div className="mt-6">
          {!data && !error && <Loader2 className="mx-auto animate-spin text-[#c9a84c]" size={22} />}
          {error && <p className="text-sm text-gray-300">{error}</p>}
          {data && data.valid && (
            <div className="space-y-2">
              <CheckCircle2 className="mx-auto text-emerald-400" size={30} />
              <p className="text-emerald-300 font-semibold">Diploma válido</p>
              <p className="text-white text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>{data.full_name}</p>
              <p className="text-sm text-gray-300">{data.course_title}</p>
              <p className="text-xs text-gray-400">Expedido el {formatIssued(data.issued_at)} · {data.code}</p>
            </div>
          )}
          {data && !data.valid && (
            <div className="space-y-2">
              <XCircle className="mx-auto text-red-400" size={30} />
              <p className="text-red-200 font-semibold">No existe ningún diploma válido con el código {String(code).toUpperCase()}</p>
            </div>
          )}
        </div>
        <p className="mt-8 text-[11px] leading-relaxed text-gray-500">
          Acreditación privada e interna de Freedom Homes Club, sin equivalencia académica oficial.
        </p>
        <Link to="/" className="mt-4 inline-block text-xs text-[#c9a84c] hover:underline">freedomhomes.club</Link>
      </div>
    </div>
  );
}
